import { Link } from 'react-router-dom';  
import paths from '../../routes/paths';  
import ReturnExchangeImage from '../../assets/images/return.png'
import MetaTags from '../Common/MetaTags';

const  ReturnExchangePolicy = () => {   
    return (
        <>
            <MetaTags
                title="Return Exchange Policy | Anuugha Collections"
                description="Explore our transparent Return and Exchange Policy designed for your satisfaction. Learn about hassle-free returns, exchange guidelines, and our commitment to ensuring a seamless shopping experience. Your satisfaction is our priority."
                url="https://www.anuughacollections.com/return-exchange-policy"
                image={process.env.REACT_APP_SERVER_URL + ReturnExchangeImage}
            />
            <div className="page-content bg-light">

                <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                    <h1>Return Exchange Policy</h1>
                    <nav aria-label="breadcrumb" className="breadcrumb-row">
                        <ul className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                        <li className="breadcrumb-item">Return Exchange Policy</li>
                        </ul>
                    </nav>
                    </div>
                </div>	
                </div>
                <section className="content-inner">
                    <div className="theme-page-section _pv-60 _ph-60 about_one shipping-policy p-t-40 m-b-60">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="theme-hero-text theme-hero-text-center">
                                        <div className="theme-hero-text-header">
                    
                                            <div className="row">
                                                <div className="col-md-4 col-6 text-image">
                                                    <img src={ReturnExchangeImage} alt="return or exchange"/>
                                                </div>
                                                <div className="col-md-8 col-6 text-free-shipping">
                                                        <div className="text p-l-60">
                                                            <h2> Return or exchange eligibility</h2>
                                                            <p>Product can be exchanged only if the product is damaged or the wrong product is received.</p> 
                                                        </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h4 className="p-t-30 p-b-20">Exchange Eligibility</h4>
                                                    <p>Orders are only eligible for exchange if:</p>
                                                    <ul>
                                                        <li>The product is clearly defective/damaged.</li>
                                                        <li>Received wrong product.</li>
                                                        <li>Reach out to Anuugha Collections Customer Care at anuughacollections@gmail.com or whatsapp +91 8499919988 within 7 days from the purchase of order to get a confirmation on the exchange eligibility of the order.</li>
                                                        <li>One of our executives will get in touch, in order to process the exchange request.</li>
                                                        <li>The customers may have to share the images of the product received in order to initiate the return pick-up.</li>
                                                        <li>A confirmation email or whatsapp message would be sent to the customer, confirming the exchange request.</li>
                                                        <li>Customers are requested not to return the products through any personal mode other than the exchange facility provided by Anuugha Collections as this may hamper/delay the exchange process.</li>
                                                        <li>Orders placed for Gift vouchers are not eligible for cancellation/ exchange.</li>
                                                    </ul>
                                                </div>
                                                
                                                <div className="col-md-12">
                                                    <h4 className="p-t-30 p-b-20">Exchange Process</h4>
                                                    <p>The product will go through the following internal checks before the exchange gets processed:</p>
                                                    <ul>
                                                        <li>The products returned should be in original condition.</li>
                                                        <li>The products must not be used or washed.</li>
                                                        <li>The products should have the original tags/labels in place and folds intact.</li>
                                                        <li>The products should be returned along with the box in which the product was delivered.</li>
                                                        <li>Unboxing video is a mandatory requirement and must be shared with us during the return process.</li>
                                                        <li>The exchange may be delayed or not get processed, if the returned product/s does not meet any one of the internal check criteria mentioned above.</li>
                                                    </ul>
                                                    <br/>
                                                    <p><b>Refund or Return Policy:</b> No refund or return is available for any product. However, in the event of damage during shipping or delivery, we offer an exchange policy. Customers may request an exchange for damaged items within 7 days of purchased date. Please reach out to anuughacollections@gmail.com or whatsapp +91 8499919988 for assistance with exchanges.</p>
                                                </div>   
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> 
        
            </div>
      </> 
    );
}

export default ReturnExchangePolicy;

 
